import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "2",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    fill: "black"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute right-8 mt-2 w-56 rounded-xl shadow-xl text-xs overflow-hidden z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Job Detail")
], -1)
const _hoisted_7 = { class: "flex flex-row space-x-3 items-center text-gray-600" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 8V13",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "4",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22 12C22 13.6569 20.6569 15 19 15C17.3431 15 16 13.6569 16 12",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 12.3345 21.2531 12.6221 21.5872 12.6396L22.2654 12.6751C22.6599 12.6958 23 12.395 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C14.2483 23 16.339 22.3255 18.0809 21.1678C18.8987 20.6243 18.4752 19.4861 17.4946 19.4347C17.2409 19.4214 16.9914 19.4945 16.7762 19.6295C15.392 20.4979 13.7546 21 12 21C7.02944 21 3 16.9706 3 12Z",
    fill: "black"
  })
], -1)
const _hoisted_9 = { class: "font-semibold ml-4" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-center text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Assign template")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "flex flex-row space-x-3 items-center text-gray-600" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.4609 10.8779L8.69317 9.11016",
    stroke: "#A0A3BD",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.3535 16.7705L15.175 15.592",
    stroke: "#A0A3BD",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.416 14.1191L14.2912 14.7084L13.702 18.8332L10.1664 15.2977L10.7557 11.1729L14.8805 10.5836L18.416 14.1191Z",
    stroke: "#A0A3BD",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5732 7.58793C12.37 7.06935 12.0589 6.58328 11.6398 6.16426C10.0127 4.53708 7.37448 4.53708 5.74729 6.16426C4.12011 7.79145 4.12011 10.4296 5.74729 12.0568C6.16631 12.4758 6.65238 12.787 7.17096 12.9902",
    stroke: "#A0A3BD",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8023 6.71532C15.4451 5.65244 14.8432 4.65371 13.9965 3.80704C11.0676 0.878107 6.31882 0.878107 3.38989 3.80704C0.460959 6.73597 0.460959 11.4847 3.38989 14.4136C4.23656 15.2603 5.23529 15.8622 6.29817 16.2194",
    stroke: "#A0A3BD",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_15 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsMenuOpen(!_ctx.isMenuOpen))),
      type: "button",
      class: "select-none hover:bg-gray-100 rounded"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: `/job-candidates-detail?id=${_ctx.jobId}`,
                    class: "rounded px-4 py-2 my-1 hover:bg-background"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  (_ctx.showAssing)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.assignJob && _ctx.assignJob(...args))),
                        class: "rounded px-4 py-2 my-1 hover:bg-background disabled:opacity-30"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.hasRecruiter
                    ? "Reassign to a recruiter"
                    : "Assign to a recruiter"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    disabled: _ctx.hasEvaluation,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openEvaluation && _ctx.openEvaluation(...args))),
                    class: "rounded px-4 py-2 my-1 hover:bg-background disabled:opacity-30"
                  }, _hoisted_12, 8, _hoisted_10),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deactivateJob && _ctx.deactivateJob(...args))),
                    class: "rounded px-5 py-2 my-1 hover:bg-background disabled:opacity-30"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.isClosedJob ? "Open job" : "Close job"), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}